module.exports = __webpack_public_path__ + "static/media/113.5c12a996.jpg";